import $ from 'jquery';
import whatInput from 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = $;
import Foundation from 'foundation-sites';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

$(document).on('click', 'a[href^="#"]:not([role="tab"]):not([data-open]):not([data-toggle])', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});


// A $( document ).ready() block.
// $( function() {

    $('.sidebar-link').click(function(){
      $('.sidebar-link').removeClass('active-sidebar-link');
      $(this).addClass('active-sidebar-link');
    });

    // AniElements();

    var observer = new IntersectionObserver(function(entries) {
        // isIntersecting is true when element and viewport are overlapping
        // isIntersecting is false when element and viewport don't overlap
        for(let i=0; i<entries.length; i++) {
            var entry = entries[i]['target'];
            if(entries[i].isIntersecting === true){
                
                entry.classList.add("opacity-show");
            } else{
                entry.classList.remove("opacity-show");
            }
        }
    }, { threshold: [0] });
    
    $('.gw-animate').each(function(){
        var p_id = $(this).attr('id');
        observer.observe(document.querySelector('#'+p_id));
    });
    

    
// });

// function AniElements(){
//     const selectors = [
//       ".hero-main",
//       ".slider-main",
//       ".cta-main",
//       ".wp-block-gw-xy-grid",
//       ".site-header",
//       ".site-footer",
//       ".page-header",
//       ".main-container",
//       ".employee-link-cont",
//       ".footer-cta-main",
//       ".single-year"
//     ];

//     selectors.forEach(selector => {
//       // GWObserve("opacity-show", selector);
//     });
// }

// function GWObserve(classToAdd, targetClass) {
//   const observer = new IntersectionObserver(intersections => {
//     intersections.forEach(({
//       target,
//       isIntersecting
//     }) => {
      
//       if (isIntersecting) {
//         // Element is in the viewport, so stop observing it
//         target.classList.toggle(classToAdd, isIntersecting);
//         observer.unobserve(target);
//       }
//       else{
//         target.classList.toggle(classToAdd, isIntersecting);
//       }
//     });
//   }, {
//     threshold: 0
//   });

//   document.querySelectorAll(targetClass).forEach(div => {
//     observer.observe(div);
//   });
// }
